import React, { useContext } from 'react';
import ironSerialImage from '../../../assets/images/serial-location-irons@2x.png';
import putterSerialImage from '../../../assets/images/serial-location-putters@2x.png';
import woodSerialImage from '../../../assets/images/serial-location-drivers@2x.png';
import Styles from './InfoItems.module.scss';

const InfoItems = (props) => {
  const { localization } = props;
  const infoItems = [
    {
      image: ironSerialImage,
      description: localization.iron,
    },
    {
      image: woodSerialImage,
      description: localization.wood,
    },
    {
      image: putterSerialImage,
      description: localization.putter,
    },
  ];
  return (
    <div className={Styles.infoItemsContainer}>
      {infoItems.map((item, index) => {
        return (
          <div key={index} className={Styles.infoItem}>
            <div>{item.image ? <img src={item.image} /> : ''}</div>
            <div dangerouslySetInnerHTML={{
              __html: item.description ? item.description : '',
            }}>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default InfoItems;
